export default function Loading(store) {
    this.store = store

    this.on = function(key) {
        this.store.commit('loading/set', {key: key, state: true})
    }

    this.off = function(key) {
        this.store.commit('loading/set', {key: key, state: false})
    }

    this.get = function(key) {
        var list = this.store.state.loading.list
        // //check if exist
        if(list[key]) {
            return list[key]
        } else {
            this.store.commit('loading/set', {key: key, state: false})

            return false
        }
    }
}